import { slide } from './shared/sliding.mjs';

/**
 * Expand a solver solution into one frame per move.
 *
 * The solver answers in moves — "orange right" — but the board draws
 * positions, and each move only makes sense from where the previous one left
 * the robots. `buildFrames` does that replay once, up front, so playback is a
 * cursor over an array rather than a running simulation: a frame can be
 * rendered on its own, and stopping halfway needs no unwinding.
 *
 * Sliding is the shared engine, not a copy of it — a solution that could not
 * be played by hand must not be playable here either.
 *
 * @param {object} boardState  where the robots start, `{ [color]: {x, y} }`
 * @param {object} walls       wall map from `buildWallMap()`
 * @param {Array}  moves       `[{ color, direction }]` from the solver
 * @returns {Array} `[{ color, from, to, positions }]` — `positions` is the
 *   whole board *after* that move.
 */
export function buildFrames(boardState, walls, moves) {
  if (!boardState || !moves?.length) return [];

  let positions = { ...boardState };

  return moves.map(({ color, direction }) => {
    const from = positions[color];
    const to = slide(positions, walls, color, direction);
    positions = { ...positions, [color]: to };
    return { color, from, to, positions };
  });
}

export default buildFrames;
